package br.com.htms.inspeccaocampo.ui.screens

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Button
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Checkbox
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.ExposedDropdownMenuBox
import androidx.compose.material3.ExposedDropdownMenuDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.PasswordVisualTransformation
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.auth.AuthApi
import br.com.htms.inspeccaocampo.auth.AuthUserListItem
import br.com.htms.inspeccaocampo.auth.ProfileTypes
import br.com.htms.inspeccaocampo.shared.ui.components.FormFieldDefaults
import kotlinx.coroutines.launch

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun SharedAdminUsersPanel(
    onMessage: (String) -> Unit
) {
    var users by remember { mutableStateOf<List<AuthUserListItem>>(emptyList()) }
    var loading by remember { mutableStateOf(true) }
    var novoUser by remember { mutableStateOf("") }
    var novaSenha by remember { mutableStateOf("") }
    var novoRole by remember { mutableStateOf("user") }
    var novoTst by remember { mutableStateOf(true) }
    var novoAdm by remember { mutableStateOf(false) }
    var roleMenu by remember { mutableStateOf(false) }
    var editingId by remember { mutableStateOf<String?>(null) }
    var editTst by remember { mutableStateOf(true) }
    var editAdm by remember { mutableStateOf(false) }
    var editRole by remember { mutableStateOf("user") }
    var editRoleMenu by remember { mutableStateOf(false) }
    var editSenha by remember { mutableStateOf("") }
    val scope = rememberCoroutineScope()

    fun selectedTypes(tst: Boolean, adm: Boolean): List<String> = buildList {
        if (tst) add(ProfileTypes.TST)
        if (adm) add(ProfileTypes.ADM)
    }

    fun senhaForte(senha: String): Boolean {
        if (senha.length < 8) return false
        if (!senha.any { it.isLetter() }) return false
        if (!senha.any { it.isDigit() }) return false
        return true
    }

    fun recarregar() {
        scope.launch {
            loading = true
            AuthApi.listUsers()
                .onSuccess {
                    // Master `admin` já vem oculto da API; reforço no client.
                    users = it.filter { u -> !u.username.equals("admin", ignoreCase = true) }
                }
                .onFailure { onMessage(it.message ?: "Falha ao listar usuários") }
            loading = false
        }
    }

    LaunchedEffect(Unit) { recarregar() }

    Card(
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surfaceVariant),
        modifier = Modifier.fillMaxWidth()
    ) {
        Column(
            Modifier.padding(12.dp),
            verticalArrangement = Arrangement.spacedBy(10.dp)
        ) {
            Text("Administração de usuários", fontWeight = FontWeight.Bold)
            Text(
                "Tipo de campo (TST/ADM) define quais formulários aparecem no hub. " +
                    "Role Admin gerencia usuários/obras e vê o histórico de todos; também preenche formulários.",
                style = MaterialTheme.typography.bodySmall
            )

            OutlinedTextField(
                value = novoUser,
                onValueChange = { novoUser = it },
                label = { Text("Novo usuário") },
                singleLine = true,
                modifier = Modifier.fillMaxWidth(),
                colors = FormFieldDefaults.textFieldColors()
            )
            OutlinedTextField(
                value = novaSenha,
                onValueChange = { novaSenha = it },
                label = { Text("Senha (mín. 8, letra e número)") },
                singleLine = true,
                visualTransformation = PasswordVisualTransformation(),
                modifier = Modifier.fillMaxWidth(),
                colors = FormFieldDefaults.textFieldColors()
            )
            ExposedDropdownMenuBox(
                expanded = roleMenu,
                onExpandedChange = { roleMenu = it }
            ) {
                OutlinedTextField(
                    value = if (novoRole == "admin") "Admin (sistema)" else "Usuário",
                    onValueChange = {},
                    readOnly = true,
                    label = { Text("Role do sistema") },
                    trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(expanded = roleMenu) },
                    modifier = Modifier
                        .fillMaxWidth()
                        .menuAnchor(),
                    colors = FormFieldDefaults.textFieldColors()
                )
                androidx.compose.material3.DropdownMenu(
                    expanded = roleMenu,
                    onDismissRequest = { roleMenu = false }
                ) {
                    DropdownMenuItem(
                        text = { Text("Usuário") },
                        onClick = {
                            novoRole = "user"
                            roleMenu = false
                        }
                    )
                    DropdownMenuItem(
                        text = { Text("Admin (sistema)") },
                        onClick = {
                            novoRole = "admin"
                            roleMenu = false
                        }
                    )
                }
            }
            Text("Tipo de campo *", fontWeight = FontWeight.SemiBold)
            Row(verticalAlignment = Alignment.CenterVertically) {
                Checkbox(checked = novoTst, onCheckedChange = { novoTst = it })
                Text("TST (Inspeção + Ocorrências)")
            }
            Row(verticalAlignment = Alignment.CenterVertically) {
                Checkbox(checked = novoAdm, onCheckedChange = { novoAdm = it })
                Text("ADM (Relatório Alojamento)")
            }
            Button(
                onClick = {
                    val types = selectedTypes(novoTst, novoAdm)
                    if (types.isEmpty()) {
                        onMessage("Selecione TST e/ou ADM")
                        return@Button
                    }
                    if (!senhaForte(novaSenha)) {
                        onMessage("Senha: mín. 8 caracteres, com letra e número")
                        return@Button
                    }
                    scope.launch {
                        AuthApi.createUser(novoUser.trim(), novaSenha, novoRole, types)
                            .onSuccess {
                                onMessage("Usuário ${it.username} criado.")
                                novoUser = ""
                                novaSenha = ""
                                novoRole = "user"
                                novoTst = true
                                novoAdm = false
                                recarregar()
                            }
                            .onFailure { onMessage(it.message ?: "Falha ao criar") }
                    }
                },
                modifier = Modifier.fillMaxWidth(),
                enabled = novoUser.isNotBlank() && senhaForte(novaSenha) && (novoTst || novoAdm)
            ) {
                Text("Adicionar usuário")
            }

            Text(
                if (loading) "Carregando..." else "Usuários (${users.size})",
                fontWeight = FontWeight.SemiBold
            )
            users.forEach { u ->
                Column(
                    modifier = Modifier.fillMaxWidth().padding(vertical = 4.dp),
                    verticalArrangement = Arrangement.spacedBy(4.dp)
                ) {
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.SpaceBetween,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Column(modifier = Modifier.weight(1f)) {
                            Text(u.username, fontWeight = FontWeight.Medium)
                            Text(
                                buildString {
                                    append(if (u.role.equals("admin", true)) "Admin" else "Usuário")
                                    append(" · ")
                                    append(ProfileTypes.label(u.profileTypes))
                                },
                                style = MaterialTheme.typography.bodySmall
                            )
                        }
                        TextButton(
                            onClick = {
                                if (editingId == u.id) {
                                    editingId = null
                                    editSenha = ""
                                } else {
                                    editingId = u.id
                                    editSenha = ""
                                    editTst = u.profileTypes.any { it.equals(ProfileTypes.TST, true) }
                                    editAdm = u.profileTypes.any { it.equals(ProfileTypes.ADM, true) }
                                    editRole = if (u.role.equals("admin", true)) "admin" else "user"
                                }
                            }
                        ) { Text(if (editingId == u.id) "Fechar" else "Editar") }
                        TextButton(
                            onClick = {
                                scope.launch {
                                    AuthApi.deleteUser(u.id)
                                        .onSuccess {
                                            onMessage("Removido: ${u.username}")
                                            if (editingId == u.id) editingId = null
                                            recarregar()
                                        }
                                        .onFailure {
                                            onMessage(
                                                it.message
                                                    ?: "Falha ao remover. Verifique a conexão."
                                            )
                                        }
                                }
                            }
                        ) { Text("Remover") }
                    }
                    if (editingId == u.id) {
                        ExposedDropdownMenuBox(
                            expanded = editRoleMenu,
                            onExpandedChange = { editRoleMenu = it }
                        ) {
                            OutlinedTextField(
                                value = if (editRole == "admin") "Admin (sistema)" else "Usuário",
                                onValueChange = {},
                                readOnly = true,
                                label = { Text("Role do sistema") },
                                trailingIcon = {
                                    ExposedDropdownMenuDefaults.TrailingIcon(expanded = editRoleMenu)
                                },
                                modifier = Modifier.fillMaxWidth().menuAnchor(),
                                colors = FormFieldDefaults.textFieldColors()
                            )
                            androidx.compose.material3.DropdownMenu(
                                expanded = editRoleMenu,
                                onDismissRequest = { editRoleMenu = false }
                            ) {
                                DropdownMenuItem(
                                    text = { Text("Usuário") },
                                    onClick = {
                                        editRole = "user"
                                        editRoleMenu = false
                                    }
                                )
                                DropdownMenuItem(
                                    text = { Text("Admin (sistema)") },
                                    onClick = {
                                        editRole = "admin"
                                        editRoleMenu = false
                                    }
                                )
                            }
                        }
                        Row(verticalAlignment = Alignment.CenterVertically) {
                            Checkbox(checked = editTst, onCheckedChange = { editTst = it })
                            Text("TST")
                            Checkbox(checked = editAdm, onCheckedChange = { editAdm = it })
                            Text("ADM")
                        }
                        OutlinedTextField(
                            value = editSenha,
                            onValueChange = { editSenha = it },
                            label = { Text("Nova senha (opcional — mín. 8, letra e número)") },
                            singleLine = true,
                            visualTransformation = PasswordVisualTransformation(),
                            modifier = Modifier.fillMaxWidth(),
                            colors = FormFieldDefaults.textFieldColors()
                        )
                        Button(
                            onClick = {
                                val types = selectedTypes(editTst, editAdm)
                                if (types.isEmpty()) {
                                    onMessage("Selecione TST e/ou ADM")
                                    return@Button
                                }
                                if (editSenha.isNotBlank() && !senhaForte(editSenha)) {
                                    onMessage("Senha: mín. 8 caracteres, com letra e número")
                                    return@Button
                                }
                                scope.launch {
                                    AuthApi.updateUser(
                                        u.id,
                                        role = editRole,
                                        profileTypes = types,
                                        password = editSenha.trim().ifBlank { null }
                                    )
                                        .onSuccess {
                                            onMessage(
                                                if (editSenha.isNotBlank()) {
                                                    "Usuário ${it.username} atualizado (senha alterada)."
                                                } else {
                                                    "Usuário ${it.username} atualizado."
                                                }
                                            )
                                            editingId = null
                                            editSenha = ""
                                            recarregar()
                                        }
                                        .onFailure {
                                            onMessage(it.message ?: "Falha ao atualizar")
                                        }
                                }
                            },
                            enabled = editTst || editAdm,
                            modifier = Modifier.fillMaxWidth()
                        ) {
                            Text("Salvar alterações")
                        }
                    }
                }
            }
            OutlinedButton(onClick = { recarregar() }, modifier = Modifier.fillMaxWidth()) {
                Text("Atualizar lista")
            }
        }
    }
}
